import { gql } from '@apollo/client';
const UPDATE_PRODUCT = gql `
  mutation UpdateProduct(
    $productId: ID!
    $productDescription: String
    $supplierId: ID!
    $name: String!
    $composition: String
    $grammage: String
    $width: String
    $componentSize: String
    $zipperType: String
    $producerCode: String
    $underSliderType: String
    $upperSliderType: String
    $yardage: String
    $properName: String
    $orderOperatorId: String!
    $productionTimeDays: Int
    $continentId: ID
    $countryId: ID
    $eventId: ID
    $mainCategoryId: ID
    $functionIds: [ID]
    $sustainabilityIds: [ID]
    $certificateIds: [ID]
  ) {
    updateProduct(
      productId: $productId
      productDescription: $productDescription
      supplierId: $supplierId
      name: $name
      composition: $composition
      grammage: $grammage
      width: $width
      componentSize: $componentSize
      zipperType: $zipperType
      producerCode: $producerCode
      underSliderType: $underSliderType
      upperSliderType: $upperSliderType
      yardage: $yardage
      properName: $properName
      orderOperatorId: $orderOperatorId
      productionTimeDays: $productionTimeDays
      continentId: $continentId
      countryId: $countryId
      eventId: $eventId
      mainCategoryId: $mainCategoryId
      functionIds: $functionIds
      sustainabilityIds: $sustainabilityIds
      certificateIds: $certificateIds
    ) {
      product {
        id
        name
        properName
        productDescription
        productionTimeDays
        pictures {
          edges {
            node {
              id
              image
            }
          }
        }
        supplier {
          id
          code
          shortName
          fullName
        }
        orderOperator {
          id
          name
        }
        continent {
          id
          name
          description
          thumbnail
        }
        country {
          id
          name
        }
        event {
          id
          name
          description
          thumbnail
        }
        mainCategory {
          id
          name
          description
          thumbnail
        }
        functions {
          edges {
            node {
              id
              name
              description
              thumbnail
            }
          }
        }
        sustainabilities {
          edges {
            node {
              id
              name
              description
              thumbnail
            }
          }
        }
        certificates {
          edges {
            node {
              id
              name
              description
              thumbnail
            }
          }
        }
        zipperType {
          id
          name
          upperSlider
          underSlider
        }
        grammage {
          id
          name
        }
        componentSize {
          id
          name
        }
        width {
          id
          name
        }
        composition {
          id
          name
        }
        producerCode {
          id
          name
        }
        underSliderType {
          id
          name
        }
        upperSliderType {
          id
          name
        }
        yardage {
          id
          name
        }
        category {
          id
          type
          typeLabelPL
          typeLabelEN
          typeIcon
          hasName
          hasComposition
          hasComponentSize
          hasSupplier
          hasProductDescription
          hasWidth
          hasZipperType
          variantHasColor
          variantHasChainColor
          variantHasTapeColor
          variantHasSliderColor
          variantHasSize
          hasGrammage
          hasProducerCode
          hasUnderSliderType
          hasUpperSliderType
          hasYardage
          colorAutoCalculationMethod
        }
        dataHash
        snapshots {
          edges {
            node {
              id
              isUpToDate
            }
          }
        }
      }
    }
  }
`;
export default UPDATE_PRODUCT;
